module.exports = __webpack_public_path__ + "static/media/download_app_ad.068cbfca.png";